import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHypertrackerBuilderMenuItem = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_3437_36172)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M15.0733 12.6667L9.01997 6.60666C9.63997 5.04666 9.33331 3.20666 8.05997 1.93999C6.52664 0.406658 4.13997 0.266658 2.43997 1.50666L4.99997 4.07332L4.05331 4.99999L1.49997 2.45999C0.259974 4.15332 0.399974 6.54666 1.93331 8.07332C3.17331 9.31332 4.97997 9.63999 6.52664 9.05999L12.6 15.1333C12.86 15.3933 13.28 15.3933 13.54 15.1333L15.0733 13.6C15.3333 13.3333 15.3333 12.9267 15.0733 12.6667ZM13.0733 13.7267L6.76664 7.41999C6.35997 7.71999 5.90664 7.89999 5.43331 7.96666C4.52664 8.09999 3.57331 7.82666 2.87997 7.13332C2.24664 6.50666 1.95331 5.66666 1.99997 4.83999L4.05997 6.89999L6.88664 4.07332L4.82664 1.99999C5.66664 1.96666 6.48664 2.25999 7.11997 2.88666C7.46092 3.22709 7.71424 3.64512 7.85821 4.10492C8.00219 4.56472 8.03253 5.05256 7.94664 5.52666C7.86341 6.00441 7.66171 6.45367 7.35997 6.83332L13.6666 13.1333L13.0733 13.7267Z",
			fill: "currentColor"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_3437_36172",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 16,
			height: 16,
			fill: "white"
		})
	}) })]
});
export default SvgHypertrackerBuilderMenuItem;
